// extracted by mini-css-extract-plugin
export var fileUpload = "_gy-1";
export var modalButton = "_gy-0";